// redux/actions/junta/types.js
export const FETCH_JUNTA_SUCCESS = "FETCH_JUNTA_SUCCESS";
export const FETCH_JUNTA_FAILURE = "FETCH_JUNTA_FAILURE";
export const FETCH_JUNTA_DETALLES_SUCCESS = "FETCH_JUNTA_DETALLES_SUCCESS";
export const FETCH_JUNTA_DETALLES_FAILURE = "FETCH_JUNTA_DETALLES_FAILURE";
